import React, { useState } from 'react'
import AttachmentsInputField from 'src/components/AttachmentsInputField/AttachmentsInputField'
import BottomBox from 'src/components/BottomBox/BottomBox'
import ErrorList from 'src/components/ErrorList/ErrorList'
import { useTranslate } from 'src/localization/Trns'
import { ReceiptAttachmentModel } from 'src/models/receiptAttachment.models'
import { PostReceiptAttachmentRequest } from 'src/requests/postReceiptAttachment.request'
import { css } from 'styled-components'

interface AttachmentsInputBoxProps {
  sectionHeader?: React.ReactNode
  sectionSubheader?: React.ReactNode
  receiptAttachments: ReceiptAttachmentModel[]
  uploadingAttachmentThumbnails?: Record<string, string>
  uploadAttachments?: (attachments: PostReceiptAttachmentRequest[]) => void
  deleteAttachment: (attachmentId: string) => void
  id?: string
}

const AttachmentsInputBox: React.FC<AttachmentsInputBoxProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const [attachmentError, setAttachmentError] = useState<
    string | React.ReactElement | undefined
  >()

  return (
    <BottomBox
      label={props.sectionHeader ?? translate('Attachments')}
      collapsible
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <AttachmentsInputField
        receiptAttachments={props.receiptAttachments}
        uploadingAttachmentThumbnails={props.uploadingAttachmentThumbnails}
        uploadAttachments={props.uploadAttachments}
        deleteAttachment={props.deleteAttachment}
        id={props.id}
        setAttachmentError={setAttachmentError}
        additionalContextCopy={props.sectionSubheader}
        css={css`
          &:nth-child(n + 2) {
            margin-top: 24px;
          }
        `}
      />
      {attachmentError && (
        <ErrorList
          errors={[attachmentError]}
          css={css`
            padding-left: 0;
          `}
        />
      )}
    </BottomBox>
  )
}

export default AttachmentsInputBox
